import '../base';
import '../components/carousels/mobile-carousel';
import '../components/product/before-after-sliders';
import KeenSlider from 'keen-slider';

import {
  initCarousel,
  CarouselOptions,
  InitCarouselParams,
} from '../objects/carousel';
import {
  responsiveMediaAbove,
  responsiveMediaBelow,
  responsiveQuery,
} from '../settings/responsive';
import { CLASS_INITIALISED } from '../tools/constants/classes';

const SELECTOR_CONTAINER = '[data-reviews]';
const SELECTOR_CAROUSEL = '[data-reviews-carousel]';
const ATTR_NO_DESKTOP_CAROUSEL = 'data-no-desktop-carousel';
const SELECTOR_NAV_NEXT = '[data-carousel-next]';
const SELECTOR_NAV_PREV = '[data-carousel-previous]';

document.querySelectorAll(SELECTOR_CONTAINER).forEach((container) => {
  const carouselElement =
    container.querySelector<HTMLElement>(SELECTOR_CAROUSEL);
  const noCarouselDesktop = container.hasAttribute(ATTR_NO_DESKTOP_CAROUSEL);
  const nextArrow = container.querySelector(SELECTOR_NAV_NEXT);
  const prevArrow = container.querySelector(SELECTOR_NAV_PREV);
  const beforeAfterImages = container.querySelectorAll<HTMLElement>('[data-before-after-image-container]');

  let options;
  options = {
    slidesPerView: 1.25,
    spacing: 24,
    loop: true,
    controls: true,
    breakpoints: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '(min-width: 550px)': {
        slidesPerView: 1.8,
      },
      [responsiveQuery('SMALL')]: {
        slidesPerView: 2.4,
        loop: true,
        centered: false,
      },
      [responsiveQuery('MEDIUM')]: {
        slidesPerView: 3,
        loop: true,
        spacing: 32,
        centered: false,
      },
    },
  };

  if (noCarouselDesktop) {
    options = {
      slidesPerView: 1.25,
      spacing: 24,
      loop: true,
      breakpoints: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '(min-width: 550px)': {
          slidesPerView: 1.8,
          loop: true,
        },
        [responsiveQuery('SMALL')]: {
          slidesPerView: 2.4,
          centered: true,
          loop: true,
        },
        [responsiveQuery('MEDIUM')]: {
          created: (slider: KeenSlider) => slider.destroy(),
        },
      },
    };
  }

  if (!carouselElement) return;

  nextArrow?.addEventListener('click', () => {
    if (!carousel) return;
    carousel.slider.next();
  });
  prevArrow?.addEventListener('click', () => {
    if (!carousel) return;
    carousel.slider.prev();
  });

  const params: InitCarouselParams = { container: carouselElement, options };
  const carousel = initCarousel(params);

  // Remove carousel functionality on medium breakpoint and above on resize and load
  const onResize = () => {
    if (!carousel) return;
    const slider = carousel.slider;
    if (responsiveMediaAbove('MEDIUM')) {
      slider.destroy();
    } else if (responsiveMediaBelow('MEDIUM')) {
      slider.refresh();
    }
  };

  beforeAfterImages.forEach((beforeAfterImage) => {
    beforeAfterImage.addEventListener('mouseup', () => {
      carousel.slider.controls(true);
    });
  });

  if (noCarouselDesktop) {
    window.addEventListener('resize', onResize);
  }
});
